import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
const Loading = ({ message = "Cargando..." }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '50vh', gap: 2, animation: 'fadeIn 0.3s ease both' }}>
    <Box sx={{ width: 56, height: 56, borderRadius: 'var(--radius-lg)', backgroundColor: 'var(--accent-soft)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <CircularProgress size={28} thickness={4} sx={{ color: 'var(--accent)' }} />
    </Box>
    <Typography sx={{ fontFamily: 'var(--font-body)', fontSize: '0.9rem', color: 'var(--text-muted)', fontWeight: 500 }}>{message}</Typography>
  </Box>
);
export default Loading;
